module.exports = __webpack_public_path__ + "static/img/tx6.8f728bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/tx6.jpg
// module id = 6eU7
// module chunks = 4